import React, { Component, useState } from "react";
import {
  Grid,
  LinearProgress,
  Select,
  OutlinedInput,
  MenuItem,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";

// styles
import useStyles from "./styles";
import FileInput from '../../widgets/ImageInput';
import TextInput from '../../widgets/TextInput';
import BooleanInput from '../../widgets/BooleanInput';
import ColorInput from '../../widgets/ColorInput';
import SliderInput from '../../widgets/SliderInput';
import DragableWidgetsList from '../../widgets/DraggableWidgetsList';

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import saveSection from '../../services/saveSection';
import deleteSection from '../../services/deleteSection';
import getSection from '../../services/getSection';
import escapeString from '../../utils/utils';
import ReactDOM from "react-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import cloneDeep from 'lodash/cloneDeep';
import _ from '../../utils/languages/languages';

import {
  Delete as DeleteIcon,
} from "@material-ui/icons";

export default class MenuPage extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = 'Menu'

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      indexOver: -1
    }

    this.grid = 2;

    this.selectOptions = [
      {
        value: '',
        label: '',
      },
      {
        value: 'custom',
        label: 'Editor',
      },
      {
        value: 'attractions',
        label: 'Lista',
      },
/*      {
        value: 'map',
        label: 'Mappa',
      },  */
      {
        value: 'photogallery',
        label: 'Galleria Fotografica',
      },
    ];

    this.defaultList = [
      {
        progress: 1,
        name: 'Home Page',
        section: 'HomePage',
        type: 'custom',
        userDefined: false,
      },
      {
        progress: 2,
        name: 'Ristoranti',
        section: 'Ristoranti',
        type: 'attractions',
        userDefined: false,
      },
      {
        progress: 3,
        name: 'Attrazioni',
        section: 'Attrazioni',
        type: 'attractions',
        userDefined: false,
      },
      {
        progress: 4,
        name: 'Mappa',
        section: 'Mappa',
        type: 'map',
        userDefined: false,
      },
      {
        progress: 5,
        name: 'Contattaci',
        section: 'Contattaci',
        type: 'custom',
        userDefined: false,
      },
      {
        progress: 6,
        name: 'Photo Gallery',
        section: 'UserGallery',
        type: 'photogallery',
        userDefined: false,
      },
    ];

    this.state = {
      rawItems: this.defaultList,
      items: this.getItems(this.defaultList),
      addElementVisible: false,
      selectedOption: this.selectOptions[0].value
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items
    });
  }

  async componentDidMount(){

    const cookies = new Cookies();
    const appId = cookies.get('appId', { path: '/' });
    const resp = await getSection(appId, this.section);

    try {
      const respJson = JSON.parse(resp);
      const res = JSON.parse(respJson.result);
      this.originalResult = res;
      
      this.setState({
        rawItems: this.defaultList,
        items: this.getItems(respJson.result === "{}" ? this.defaultList : res),
      });

      if (Object.keys(res).length != 0)
        this.defaultList = res;

    } catch(error){}
  }

  async save(){
    const cookies = new Cookies();
    const token = cookies.get('token', { path: '/' });
    const appId = cookies.get('appId', { path: '/' });
    const username = cookies.get('username', { path: '/' });

    console.log(JSON.stringify(this.state));

    var listToBeSaved = [];
    this.state.items.map((k, v) => {
      this.defaultList.map ((kk, vv) => {
        if (k.progress === kk.progress){
          listToBeSaved.push(kk);
        }
      });
    });

    await saveSection(username, token, appId, this.section, listToBeSaved);

    if (this.originalResult.length != listToBeSaved.length){
      for (let i  = 0; i < this.originalResult.length; i++){
        let found = false;
        for (let ii  = 0; ii < listToBeSaved.length; ii++){
          if (this.originalResult[i].name == listToBeSaved[ii].name)
            found = true;
        }
        if (found == false){
          await deleteSection(username, token, appId, this.originalResult[i].name);
        }
      }
    }

    window.location.reload();
  }

  // fake data generator
  getItems = itemsList =>
    Array.from({ length: itemsList.length }, (v, k) => k).map(k => ({
      id: `item-${itemsList[k].progress}`,
      progress: itemsList[k].progress,
      content: (<div 
        style={{color: '#9d98ff', fontWeight: 'bold', position: 'relative'}}>
        {itemsList[k].name}
      </div>)
    }));

    // a little function to help us with reordering the result
    reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  
  getItemStyle = (isDragging, draggableStyle, index) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: 15,
    border: '1px solid #cccccc',
    borderTop: index == 0 ? '1px solid #cccccc' : '0px solid',

    // change background colour if dragging
    background: isDragging ? "lightgreen" : "transparent",

    // styles we need to apply on draggables
    ...draggableStyle
  });

  getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "transparent",
    padding: this.grid,
    width: 350
  });

  render () {

    return (
      <>
        <PageTitle title={_.tr("Menu")} button={_.tr("Salva")} onClick={this.save.bind(this)} secondButton={_.tr("Add")} onSecondClick={() => {
          this.setState({nomeSezione: '', 
          selectedOption: this.selectOptions[0].value,
          addElementVisible: true});
        }}/>
        <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable" >
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={this.getListStyle(snapshot.isDraggingOver)}
            >
            <DragableWidgetsList key={Math.random()} state={this.state} onChangeOrder={(list) => {
              this.setState({items: list})
              }}/>

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <div style={{display: this.state.addElementVisible ? 'block' : 'none',
                    position: 'fixed',
                    left: '25%',
                    top: '20%',
                    width: '50%',
                    backgroundColor: '#ffffff',
                    border: '1px solid black',
                    zIndex: 999
          }}>
          <div style={{position: 'absolute', right: '10px', top: '10px', cursor: 'pointer'}} onClick={() => {this.setState({addElementVisible: false, selectedAddress: null})}}>X</div>
                  <div style={{width: '100%', textAlign: 'center', marginTop: '10px', fontSize: 20, fontWeight: 'bold'}}>Aggiungi nuova sezione</div>

                  <TextInput style={{padding: '5px'}} name={'Nome:'} value={this.state.nomeSezione} 
                    onChange={(text) => { this.setState({nomeSezione: text})}
                  } />

                  <select style={{
                        padding: '5px',
                        margin: '5px',
                        marginLeft: '10px',
                        marginBottom: '10px'
                  }} onChange={(event) => {
                    this.setState({selectedOption: event.target.value});
                  }}>
                    {
                      this.selectOptions.map(k => {
                        return <option value={k.value} selected={this.state.selectedOption == k.value}>{k.label}</option>
                      })
                    }
                  </select><br/>

                  <button onClick={async () => {

                    if (this.state.nomeSezione == '' || this.state.selectedOption == ''){
                      alert ('Inserire nome e tipo');
                      return;
                    }

                    var newElem = {
                      progress: this.defaultList.length + 1,
                      name: this.state.nomeSezione,
                      section: this.state.nomeSezione,
                      type: this.state.selectedOption,
                      userDefined: true,
                    }

                    const newElemArray = this.getItems([newElem]);
                    const clonedItems = cloneDeep(this.state.items);
                    clonedItems.push(newElemArray[0]);

                    this.defaultList.push(newElem);
                    this.setState({items: clonedItems, 
                        addElementVisible: false,
                        });                    

                  }} style={{marginBottom: '10px', marginLeft: '10px', padding: '10px', backgroundColor: '#FF5C93', borderColor: '#FF5C93', borderRadius: '5px', color: '#ffffff'}}>
                    Aggiungi
                  </button>

            </div>

      </>
    );
  }

}

